import AuthorizedUsersSection from '@/components/AuthorizedUsersSection'
import CloverIntegrationSection from '@/components/CloverIntegrationSection'
import HomebaseIntegrationSection from '@/components/HomebaseIntegrationSection'
import PermissionsSection from '@/components/PermissionsSection'
import QuickBooksIntegrationSection from '@/components/QuickBooksIntegrationSection'
import AccountingToolPage from '@/components/AccountingToolPage'

export default function AppSettings() {
  return (
    <AccountingToolPage
      title="Settings"
      description="QuickBooks connection, sign-in access, and related app configuration"
    >
      <AuthorizedUsersSection />
      <PermissionsSection />
      <QuickBooksIntegrationSection />
      <CloverIntegrationSection />
      <HomebaseIntegrationSection />
    </AccountingToolPage>
  )
}
